export default function getAvailableUsers(scheduleUsers, originalShiftUser, userShiftsMap) {
  const users = excludeMyselfAndShiftUser(scheduleUsers, originalShiftUser);
  return excludeUsersWithoutShiftsAvailable(users, userShiftsMap);
}

export function excludeMyselfAndShiftUser(users, shiftUser) {
  return users.filter(
    (user) =>
      !user.isMe && // because swap is only available on mine shift
      (!shiftUser || shiftUser.id !== user.id) // don't swap shift with employee who's already assigned to it
  );
}

export function excludeUsersWithoutShiftsAvailable(users, userShiftsMap) {
  return users.filter((user) => Boolean(userShiftsMap[user.id]));
}
